import { useEffect, useState } from 'react'
import styled from 'styled-components'
import { NextBtn } from '../../pages/Prologue'
import Slide from '../Slide'

const BigText = styled.p`
  text-align: center;
  font-family: Roslindale;
  font-size: 5em;
  color: white;
  margin-bottom: 0;
`
const DelayedText = styled.p`
  text-align: center;
  font-family: Roslindale;
  font-size: 5em;
  color: white;
  margin: 0;
  
  animation: fadeUp ease 3s;

  @keyframes fadeUp {
    0% {
      opacity: 0;
      transform: translateY(-100px);
    }
    50% {
      opacity: 0;
      transform: translateY(-100px);
    }
    100% {
      opacity: 1;
      transform: translateY(0);
    }
`
const DelayedMoreText = styled.p`
  text-align: center;
  font-family: Roslindale;
  font-size: 5em;
  color: white;
  margin: 0;
  
  animation: fadeUp ease 5s;
  @keyframes fadeUp {
    0% {
      opacity: 0;
      transform: translateY(-100px);
    }
    60% {
      opacity: 0;
      transform: translateY(-100px);
    }
    100% {
      opacity: 1;
      transform: translateY(0);
    }
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 30vh;
  width: 100vw;
`

const Scene8 = ({ slideId, setSlideId }) => {
  const [show, setShow] = useState(false)

  useEffect(() => {
    if (slideId !== 9) return
    setTimeout(() => {
      setShow(true)
    }, 5100)
  }, [slideId])

  if (slideId !== 9) return null

  return (
    <Slide>
      <Content>
        <BigText>You can't.</BigText>
        <DelayedText>A wave of worry hits you...</DelayedText>
        <DelayedMoreText>
          What's the point of heading out anyway?
        </DelayedMoreText>
      </Content>
      <NextBtn show={show} onClick={() => setSlideId(11)}>
        {'>'}
      </NextBtn>
    </Slide>
  )
}

export default Scene8
